import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IncorrectPaymentService } from '../../service/data/incorrect-payment.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { IncorrectPayment } from '../../model/incorrect-payment';
import { InvoiceTransaction } from '../../model/invoice-transaction';
import { PaymentService } from '../../service/data/payment.service';
import { Invoice } from '../../model/invoice';
import { TenantService } from '../../../rent/service/data/tenant.service';
import { IAutoCompleteService } from '../../../core/component/autocomplete-remote/autocomplete-remote.component';

@Component({
    selector: 'app-move-payment-form',
    templateUrl: './move-payment-form.component.html',
    styleUrls: ['./move-payment-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MovePaymentFormComponent implements OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _paymentService: PaymentService,
    private fb: FormBuilder,
    private fcf: FormControlExFactory,
    filterService: TenantService
  ) {
    this.filterService = filterService;
  }

  @Input() dataContext: {
    transaction: InvoiceTransaction;
    invoice: Invoice;
  };

  filterService: IAutoCompleteService;
  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      amount: this.fcf.createMandatory('COMMON.AMOUNT', this.dataContext.transaction.amount),
      contactId: this.fcf.createMandatory('COMMON.CONTACT', this.dataContext.invoice.invoiceRecipientContactId),
      verificationDescription: this.fcf.createMandatory('VERIFICATION.DESCRIPTION', null),
    });
  }

  cancel() {
    this._actionService.close();
  }

  private _duringCall = false;

  onSubmit() {
    if (this.form.invalid || this._duringCall) return;

    this._duringCall = true;

    this._paymentService
      .moveToBalance({
        contactId: this.form.controls.contactId.value,
        invoiceId: this.dataContext.invoice.id,
        amount: this.form.controls.amount.value,
        verificationDescription: this.form.controls.verificationDescription.value,
      })
      .subscribe(payment => {
        this._actionService.complete(payment);
        this._duringCall = false;
      });
  }
}
